import { useContext } from 'react'
import { RootStore } from '../../stores'
import { RootStoreContext } from '../../stores/root-store/root-store-context'

export const useRootStore = (): RootStore => {
  const store = useContext(RootStoreContext)

  return store
}
